import React from 'react';

export const ThinScanner = (props: { className?: string }) => {
    return (
        <svg
            width='105'
            className={props.className}
            height='104'
            viewBox='0 0 105 104'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'>
            <path
                d='M30.2778 2H13.6111C10.6643 2 7.83811 3.17063 5.75437 5.25437C3.67063 7.33811 2.5 10.1643 2.5 13.1111V29.7778M102.5 29.7778V13.1111C102.5 10.1643 101.329 7.33811 99.2456 5.25437C97.1619 3.17063 94.3357 2 91.3889 2H74.7222M74.7222 102H91.3889C94.3357 102 97.1619 100.829 99.2456 98.7456C101.329 96.6619 102.5 93.8357 102.5 90.8889V74.2222M2.5 74.2222V90.8889C2.5 93.8357 3.67063 96.6619 5.75437 98.7456C7.83811 100.829 10.6643 102 13.6111 102H30.2778'
                stroke='currentColor'
                stroke-width='4'
                stroke-linecap='round'
                stroke-linejoin='round'
            />
        </svg>
    );
};

export default ThinScanner;
